if (!customElements.get('localization-form')) {
	customElements.define(
		'localization-form',
		class LocalizationForm extends HTMLElement {
			constructor() {
				super();
				this.mql = window.matchMedia('(min-width: 750px)');
				this.elements = {
					input: this.querySelector('input[name="locale_code"]'),
					button: this.querySelector('button.localization-form__select'),
					panel: this.querySelector('.disclosure__list-wrapper'),
				};
				this.addEventListener('focusout', this.closeSelector.bind(this));
				this.elements.button.addEventListener('click', this.openSelector.bind(this));
				this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
			}
	
			hidePanel() {
				this.elements.button.setAttribute('aria-expanded', 'false');
				this.elements.panel.setAttribute('hidden', true);
			}

			onItemClick(event) {
				event.preventDefault();
				const form = this.querySelector('form');
				this.elements.input.value = event.currentTarget.dataset.value;
				if (form) form.submit();
			}
	
			openSelector() {
				this.elements.button.focus();
				this.elements.panel.toggleAttribute('hidden');
				this.elements.button.setAttribute(
					'aria-expanded',
					(this.elements.button.getAttribute('aria-expanded') === 'false').toString()
				);
			}
	
			closeSelector(event) {
				if (
					!this.contains(event.target) ||
					!this.contains(event.relatedTarget)
				) {
					this.hidePanel();
				}
			}
		}
	);
}	  